import { matchPath } from 'react-router'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'
import type { ExpertReportEntry } from '../types/expertReportTracking'

const getRoutePattern = (route: string) => getOrganizationViewUrl(':organizationUrl', route)

const EXPERT_REPORT_ENTRIES: ExpertReportEntry[] = [
  {
    availabilityKey: 'isTrialBalanceEnabled',
    hasPeriod: true,
    reportType: 'trial_balance',
    routePattern: getRoutePattern(reactRoute.organization.expertTrialBalance.getMainRoute()),
  },
  {
    availabilityKey: 'isSuppliersBalanceEnabled',
    hasPeriod: true,
    reportType: 'suppliers_balance',
    routePattern: getRoutePattern(reactRoute.organization.suppliersBalance.getMainRoute()),
  },
  {
    availabilityKey: 'isCustomersBalanceEnabled',
    hasPeriod: true,
    reportType: 'customers_balance',
    routePattern: getRoutePattern(reactRoute.organization.customersBalance.getMainRoute()),
  },
  {
    availabilityKey: 'isProfitAndLossEnabled',
    hasPeriod: true,
    reportType: 'pl',
    routePattern: getRoutePattern(reactRoute.organization.expertProfitAndLoss.getMainRoute()),
  },
  {
    availabilityKey: 'isBalanceSheetEnabled',
    hasPeriod: true,
    reportType: 'balance_sheet',
    routePattern: getRoutePattern(reactRoute.organization.expertBalanceSheet.getMainRoute()),
  },
  {
    availabilityKey: 'isVatDeclarationsEnabled',
    hasPeriod: false,
    reportType: 'vat',
    routePattern: getRoutePattern(reactRoute.organization.expertVatDeclarations.getMainRoute()),
  },
]

// Prefix match so detail routes collapse into the parent report and keep one dwell session per area.
export const resolveExpertReportEntry = (pathname: string): ExpertReportEntry | undefined =>
  EXPERT_REPORT_ENTRIES.find((entry) => matchPath({ path: entry.routePattern, end: false }, pathname))
